import { z } from "zod";

export const freeScoreLedgerSchema = z
    .object({
        listingId: z.string().nullable().catch(null),
    })
    .catch({ listingId: null })
    .or(z.undefined());
